import { render, staticRenderFns } from "./LiebaoVideo.vue?vue&type=template&id=2b618dcc&scoped=true&"
import script from "./LiebaoVideo.vue?vue&type=script&lang=ts&"
export * from "./LiebaoVideo.vue?vue&type=script&lang=ts&"
import style0 from "./LiebaoVideo.vue?vue&type=style&index=0&id=2b618dcc&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b618dcc",
  null
  
)

export default component.exports